import { render, staticRenderFns } from "./ParamMng.vue?vue&type=template&id=e4af525a&scoped=true&"
import script from "./ParamMng.vue?vue&type=script&lang=js&"
export * from "./ParamMng.vue?vue&type=script&lang=js&"
import style0 from "./ParamMng.vue?vue&type=style&index=0&id=e4af525a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4af525a",
  null
  
)

export default component.exports